import React from "react";
import { IconButton } from "@mui/material";

const DSIconButton = (props: React.ComponentProps<typeof IconButton>) => {
  return <IconButton {...props} />;
};

export default DSIconButton;
